// English: every key of the Turkish catalog, with the same placeholders.

import type { Catalog } from './tr';

export const en: Catalog = {
  appTitle: 'Versiyonbir Meeting Room',

  lobbyNewHeading: 'New meeting',
  lobbyJoinHeading: 'Join the meeting',
  lobbyMeetingCode: 'Meeting code: {code}',
  nameLabel: 'Your name',
  nameHint: 'Others in the meeting see this name.',
  languageLabel: 'The language you speak',
  languageHint: 'You hear and read people who speak another language translated into this one.',
  deviceHeading: 'Camera and microphone',
  cameraStartsOn: 'Join with my camera on',
  microphoneStartsOn: 'Join with my microphone on',
  cameraDevice: 'Camera',
  microphoneDevice: 'Microphone',
  defaultDevice: 'Default device',
  previewLabel: 'Camera preview',
  previewOff: 'Camera off',
  microphoneLevel: 'Microphone level',
  devicesError: 'The camera or microphone could not be opened. You can allow them in the browser’s address bar.',
  headphonesTip: 'We recommend headphones: the translated voice then does not get into your microphone.',
  startMeeting: 'Start the meeting',
  joinMeeting: 'Join',
  connecting: 'Connecting…',
  errorName: 'Please enter your name (48 characters at most).',
  errorConnect: 'Could not connect to the meeting. Please try again in a moment.',
  errorRateLimited: 'Too many attempts in a short time. Please try again in a minute.',
  errorInvalidLink: 'This meeting link is not valid. You can start a new meeting.',

  privacyHeading: 'Privacy',
  privacyNotice:
    'Live interpretation and note-taking are on in this meeting. Speech is transcribed and ' +
    'translated, and a summary is written at the end of the meeting. For this, audio is ' +
    'processed by Deepgram, text by Anthropic and the translated voice by ElevenLabs. Audio is ' +
    'not recorded. The ' +
    'transcript is kept only while the meeting runs and is deleted when it ends; the notes are ' +
    'shown only to the people in the meeting. The notes of a booked meeting are kept with the ' +
    'booking in Versiyonbir\u2019s CRM. The person who started the meeting may switch on an ' +
    'assistant that follows the conversation and suggests questions to them alone. Written ' +
    'messages and files reach the people in the meeting only and are not stored.',
  privacyShort: 'Live interpretation and note-taking are on: speech is transcribed and translated.',
  privacyDetails: 'Details',

  meetingCode: 'Code: {code}',
  copyInvite: 'Copy the invite link',
  inviteCopied: 'Invite link copied.',
  inviteCopyFailed: 'The link could not be copied. The link: {url}',
  openInNewTab: 'Open in a new tab',
  controlsLabel: 'Meeting controls',
  microphone: 'Microphone',
  camera: 'Camera',
  screenShare: 'Share screen',
  notes: 'Notes',
  leave: 'Leave',
  modeLabel: 'Interpretation',
  modeVoice: 'Spoken interpretation',
  modeSubtitles: 'Subtitles only',
  modeOff: 'Off',
  copilot: 'Assistant',
  copilotHeading: 'Meeting assistant',
  copilotHide: 'Hide',
  copilotStop: 'Stop the assistant',
  copilotStart: 'Start the assistant',
  copilotRunning: 'running',
  copilotStopped: 'The assistant is stopped. Start it and it follows the conversation again.',
  copilotSummaryHeading: 'What the client wants',
  copilotChecklistHeading: 'To clarify',
  copilotSuggestionsHeading: 'You could ask now',
  copilotEmpty: 'The assistant is listening; the first suggestions appear after a few sentences.',
  copilotDone: 'done',
  copilotOpen: 'open',
  startAudio: 'Start audio',
  reconnecting: 'Reconnecting…',
  interpreterPresent: 'The interpreter is in the meeting.',
  interpreterAbsent: 'The interpreter has not joined yet.',
  you: '{name} (you)',
  someone: 'A participant',
  participantCount: '{count} participants',

  subtitlesLabel: 'Live subtitles',
  subtitleTranslating: 'Translating…',
  subtitleUnclear: 'Unclear',

  transcript: 'Transcript',
  transcriptHeading: 'Transcript',
  transcriptEmpty: 'What is said appears here sentence by sentence, in your language.',
  transcriptClose: 'Close the transcript',

  chat: 'Chat',
  chatHeading: 'Chat',
  chatEmpty: 'Messages and files appear here. They reach the people in the meeting only and are not stored.',
  chatMessagesLabel: 'Messages',
  chatMessageLabel: 'Message',
  chatPlaceholder: 'Write a message',
  chatSend: 'Send',
  chatSendFile: 'Send a file',
  chatFileTooLarge: 'The file is too large: at most {max} MB.',
  chatSendFailed: 'The message could not be sent.',
  chatFileFailed: 'The file could not be sent.',
  chatSending: 'Sending… {percent}%',
  chatFile: '{name} ({size})',
  chatDownload: 'Download',
  chatClose: 'Close the chat',
  chatUnread: '{count} new',

  speaks: '{name}: {language}',
  translationOn: 'Translation on',
  translationNotNeeded: 'Everyone speaks {language}, no translation needed',
  alone: 'You are alone so far',

  notesHeading: 'Meeting notes',
  notesEmpty: 'The meeting notes will appear here at the end of the meeting.',
  notesSummary: 'Summary',
  notesDecisions: 'Decisions',
  notesActions: 'Action items',
  notesOwner: 'Owner: {owner}',
  notesDue: 'Due: {due}',
  notesClose: 'Close the notes',

  leftHeading: 'You left the meeting',
  leftUnexpected: 'The connection was lost.',
  rejoin: 'Rejoin',
  newMeeting: 'Start a new meeting',
};
